module.exports = __webpack_public_path__ + "img/before-after-2.74dc51a4.png";